import DetailMatch from './DetailMatch';

export default DetailMatch;
